<template>
  <div class="app-update">
    <p>New version is available</p>
    <p>Please refresh the page</p>
    <div class="controls">
      <button @click="refresh" class="cta-button">
        Update
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-update',
  methods: {
    refresh() {
      location.reload()
    },
  },
}
</script>

<style scoped lang="scss">
.app-update {
  position: fixed;
  height: 200px;
  width: 300px;
  background: #264678;
  z-index: 10001;
  right: 20px;
  top: 20px;
  box-shadow: $card-shadow;
  padding: 40px;
}
p {
  text-align: center;
  color: #fff;
  font-size: 18px;
}
.controls {
  margin-top: 20px;
  text-align: center;
}
</style>
